import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
    <span class="created-by">Derechos reservados por <b><a href="" target="_blank">Softgas</a></b> 2019</span>
  `,
})
export class FooterComponent {
}
